import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useNextQueryParams } from '@hooks/useNextQueryParams';
import { getAllFilterUrlParameters } from '@icommerce/filter-schema';
import { getLocale } from '@libs/constants';

export const useUrlParameterValues = () => {
  const router = useRouter();
  const locale = getLocale(router);
  const query = useNextQueryParams();
  const filterUrlParams = useMemo(() => getAllFilterUrlParameters(locale), [locale]);

  return useMemo(() => {
    if (!router.isReady) {
      return {};
    }
    return Object.keys(query).reduce<Record<string, string>>((agg, queryParam) => {
      if (filterUrlParams.includes(queryParam)) {
        return {
          ...agg,
          [queryParam]: query[queryParam] as string,
        };
      }
      return agg;
    }, {});
  }, [query, router.isReady, filterUrlParams]);
};
